import React from 'react';
import { gql, useQuery } from '@apollo/client';

import { ListingCardQuery } from '../../generated/graphql';
import ListingCardWithFragment from './listing-card-with-fragment';
import AD_COMPONENTS from '../../constants/ad-components';

export const GET_LISTING_QUERY = gql`
  query listingCard($adId: Int!, $imageFormat: ImageFormat, $quality: Int) {
    listing(adId: $adId) {
      ...ListingCard
    }
  }
  ${ListingCardWithFragment.fragment}
`;

interface ListingCardWithQueryProps {
  adId: number;
  imageFormat?: string;
  quality?: number;
}

const ListingCardWithQuery = ({
  adId,
  imageFormat,
  quality,
}: ListingCardWithQueryProps): JSX.Element | null => {
  const { data, loading } = useQuery<ListingCardQuery>(GET_LISTING_QUERY, {
    variables: { adId, imageFormat, quality },
  });

  if (loading || !data) {
    return null;
  }

  return (
    <ListingCardWithFragment
      adId={adId}
      adComponent={AD_COMPONENTS.ListingCard}
      imageFormat={imageFormat}
      quality={quality}
    />
  );
};

export default ListingCardWithQuery;
